<template>
  <label class="bb-input-textarea">
    <textarea
      :class="[
        'bb-input',
        'bb-input_textarea',
        input.isError && 'bb-input_error'
      ]"
      @keydown.enter.stop
      v-model="value"
      :disabled="input.disabled"
      v-autofocus="!!input.autofocus"
      :style="{height: input.height}"
      :placeholder="input.placeholder"
    />
    <span
      v-if="input.isError"
      class="bb-input-textarea__error"
    >
      mandatory field
    </span>
  </label>
</template>

<script>
import {get} from 'lodash'

export default {
  name: 'BBTextarea',
  props: ['input', 'model'],
  data () {
    return {
      value: ''
    }
  },
  methods: {
    setDefaultVal () {
      const value = get(this.model, this.input.model, '')
      if (value) this.value = value
    }
  },
  watch: {
    value () {
      this.$emit('input', this.value)
    }
  },
  beforeMount () {
    this.setDefaultVal()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bb-input-textarea {
    position: relative;

    &__error {
      position: absolute;
      bottom: 10px;
      right: 12px;
      font-size: 13px;
      line-height: 16px;
      font-weight: 400;
      color: $color-pomegranate;
      pointer-events: none;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/Inputs/BBTextarea.vue